import {CopyToClipboard} from 'react-copy-to-clipboard';
import Link_icon from "../../assets/images/svg/link_icon.svg";
import Alertas from "../../utilities/Alertas";

export default function ReferenciaBibliografica(props:any) {
    let template = `
    Título: ${props.titulo}
    Año de publicación: ${props.anio}
    Autores: ${props.autores}
    Colaboradores: ${props.colaboradores}
    Colección: ${props.coleccion}
    Coordinadores: ${props.coordinadores}
    Edición: ${props.edicion}
    ISBN Digital: ${props.isbnDigital}
    ISBN Impresa: ${props.isbnImpresa}
    Número de páginas: ${props.pagina}
    Página actual: ${props.paginaActual}`;
    return(
        <>
        <div>Título: {props.titulo}</div>
        <div>Año de publicacion: {props.anio}</div>
        <div>Autores: {props.autores}</div>
        <div>Colaboradores: {props.colaboradores}</div>
        <div>Colección: {props.coleccion}</div>
        <div>Coordinadores: {props.coordinadores}</div>
        <div>Edición: {props.edicion}</div>
        <div>ISBN Digital: {props.isbnDigital}</div>
        <div>ISBN Impresa: {props.isbnImpresa}</div>
        <div>Número de páginas: {props.pagina}</div>
        <div className="pagina">Página actual: {props.paginaActual}</div>
        <div className="text-right">
            <CopyToClipboard text={template}> 
                <img alt="icon_copiado" title="Copiar referencia" role="button" src={Link_icon} className="icon_socialmedia" onClick={ () =>Alertas('Referencia bibliográfica copiada correctamente al portapapeles')}/>                                   
            </CopyToClipboard>
        </div>
        </>
    )
}